// extracted by mini-css-extract-plugin
export default {"cardContainer":"InfoCard_cardContainer__gVb9d","cardIcon":"InfoCard_cardIcon__Bh3MX","cardHeader":"InfoCard_cardHeader__K0Grz","cardText":"InfoCard_cardText__3noMb"};